import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

// 路由兜底：未匹配路径展示 404（挂在 AdminLayout 子路由下，保留侧边菜单与顶栏）
const NotFound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Result
      status="404"
      title="404"
      subTitle="页面不存在或已下线，请从左侧菜单重新进入"
      extra={(
        <Button type="primary" onClick={() => navigate('/', { replace: true })}>
          返回首页
        </Button>
      )}
    />
  );
};

export default NotFound;
